import "./quotation.css";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { API_URL } from "../config";
import Swal from 'sweetalert2';
const EditQuotation = () => {
   useEffect(() => {
    document.title = "Edit Quotation | Oriflamme IT Solutions";
  }, []);

  const { id } = useParams();
  const navigate = useNavigate();
  const [quotationStages, setQuotationStages] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [products, setProducts] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [accountDetails, setAccountDetails] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [itemErrors, setItemErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

   const quotationStageOptions = quotationStages.map((stage) => ({
    value: stage.id,
    label: stage.stage,
  }));
  const companyOptions = companies.map((c) => ({
    value: c.id,
    label: c.company_name,
  }));
  const branchOptions = branches.map((b) => ({
    value: b.id,
    label: b.branch_name,
  }));

  const productOptions = products.map((p) => ({
    value: p.id,
    label: p.product_name,
  }));

  const [form, setForm] = useState({
    quot_date: getCurrentDateTime(),
    company_id: "",
    branch_id: "",
    quot_stage_id: "",
    bill_company_name: "",
    bill_customer_name: "",
    bill_address: "",
    bill_contact_number: "",
    bill_email: "",
    bill_gst: "",
    ship_company_name: "",
    ship_customer_name: "",
    ship_address: "",
    ship_contact_number: "",
    ship_email: "",
    ship_gst: "",
    freight_charge: 0,
    freight_comment: "",
    extra_discount: 0,
    tc_taxes: "",
    tc_payment: "",
    tc_shipment_charges: "",
    tc_delivery_time: "",
    tc_order_placement: "",
    tc_quote_validity: "",
    account_detail_id: "",
    quot_remarks: "",
    items: [],
  });

  const [item, setItem] = useState({
    product_id: "",
    product_name: "",
    rate: "",
    qty: "",
    discount: "",
    net: "",
    gst: "",
    amount: "",
    description: "",
  });

  // Fetch quotation data
useEffect(() => {
  const fetchWithAuth = async (url) => {
    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (res.status === 401) {
      navigate("/login");
      return null;
    }

    if (!res.ok) {
      throw new Error("Request failed");
    }

    return res.json();
  };

  const fetchData = async () => {
    try {
      // Fetch quotation details
      const quotationData = await fetchWithAuth(
        `${API_URL}/api/quotation/${id}`
      );

      if (quotationData?.data) {
        const quotation = quotationData.data;

        let formattedDate = quotation.quot_date;
        if (formattedDate && !formattedDate.includes("T")) {
          formattedDate = formattedDate.replace(" ", "T").slice(0, 16);
        }

        let quotationItems = [];
        if (
          quotation.quotation_items &&
          Array.isArray(quotation.quotation_items)
        ) {
          quotationItems = quotation.quotation_items.map((item) => ({
            product_id: item.product_id || item.product?.id || "",
            product_name: item.product?.product_name || "",
            rate: Number(item.quot_rate ?? 0),
            qty: Number(item.quot_qty ?? 0),
            discount: Number(item.quot_disc ?? 0),
            gst: Number(item.quot_gst_per ?? 0),
            net: Number(item.quot_net ?? item.quot_rate * item.quot_qty),
            amount: Number(item.quot_amount ?? 0),
            description: item.description ?? "",
          }));
        } else if (quotation.items && Array.isArray(quotation.items)) {
          quotationItems = quotation.items;
        }

        setForm({
          quot_date: formattedDate || getCurrentDateTime(),
          quot_stage_id: quotation.quot_stage_id || "",
          company_id: quotation.company_id || "",
          branch_id: quotation.branch_id || "",
          bill_company_name: quotation.bill_company_name || "",
          bill_customer_name: quotation.bill_customer_name || "",
          bill_address: quotation.bill_address || "",
          bill_contact_number: quotation.bill_contact_number || "",
          bill_email: quotation.bill_email || "",
          bill_gst: quotation.bill_gst || "",
          ship_company_name: quotation.ship_company_name || "",
          ship_customer_name: quotation.ship_customer_name || "",
          ship_address: quotation.ship_address || "",
          ship_contact_number: quotation.ship_contact_number || "",
          ship_email: quotation.ship_email || "",
          ship_gst: quotation.ship_gst || "",
          freight_charge: quotation.freight_charge || 0,
          freight_comment: quotation.freight_comment || "",
          extra_discount: quotation.extra_discount || 0,
          tc_taxes: quotation.tc_taxes || "",
          tc_payment: quotation.tc_Payment || "",
          tc_shipment_charges: quotation.tc_shipment_charges || "",
          tc_delivery_time: quotation.tc_delivery_time || "",
          tc_order_placement: quotation.tc_order_placement || "",
          tc_quote_validity: quotation.tc_quote_validity || "",
          account_detail_id: quotation.account_detail_id || "",
          quot_remarks: quotation.quot_remarks || "",
          items: quotationItems,
        });
      }

      // Fetch companies
  
      const companiesData = await fetchWithAuth(
        `${API_URL}/api/companies`
      );
      if (companiesData) {
        setCompanies(companiesData.data);
        setBranches(companiesData.branches);
      }

      // Fetch quotation stages
      const quotationStagesData = await fetchWithAuth(
        `${API_URL}/api/quotation-stages`
      );
      if (quotationStagesData) {
        setQuotationStages(quotationStagesData.data);
      }

      // Fetch products
      const productsData = await fetchWithAuth(`${API_URL}/api/products`);
      if (productsData) setProducts(productsData.data);

      // Fetch account details
      const accountData = await fetchWithAuth(
        `${API_URL}/api/account-details`
      );
      if (accountData) {
        setAccountDetails(accountData.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [id, navigate]);

  const handleQuotationStageChange = (selected) => {
    const quotationStageId = selected?.value; 
    setForm((prev) => ({
      ...prev,
      quot_stage_id: quotationStageId,
    }));
  };

  const handleBranchChange = (selected) => {
    const branchId = selected?.value;
    setForm((prev) => ({  
      ...prev,
      branch_id: branchId,
    }));
  }


  const handleCompanyChange = (selected) => {
    const companyId = selected?.value;
    const selectedCompany = companies.find((c) => c.id == companyId);

    setForm((prev) => ({
      ...prev,
      company_id: companyId,
      bill_company_name: selectedCompany?.company_name || "",
      bill_customer_name: selectedCompany?.contact_person_name || "",
      bill_address: selectedCompany?.address || "",
      bill_contact_number: selectedCompany?.contact_person_mobile || "",
      bill_email: selectedCompany?.company_email || "",
      bill_gst: selectedCompany?.company_gst || "",
      ship_company_name: selectedCompany?.company_name || "",
      ship_customer_name: selectedCompany?.contact_person_name || "",
      ship_address: selectedCompany?.address || "",
      ship_contact_number: selectedCompany?.contact_person_mobile || "",
      ship_email: selectedCompany?.company_email || "",
      ship_gst: selectedCompany?.company_gst || "",
    }));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleExtraChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleProductChange = (selected) => {
    const productId = selected?.value;
    const selectedProduct = products.find((p) => p.id == productId);

    setItem((prev) => ({
      ...prev,
      product_id: productId,
      product_name: selectedProduct?.product_name || "",
      rate: selectedProduct?.product_price || "",
      gst: selectedProduct?.tax || "",
    }));
  };

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    let updatedItem = { ...item, [name]: value };

    const rate = Number(updatedItem.rate || 0);
    const qty = Number(updatedItem.qty || 0);
    const discount = Number(updatedItem.discount || 0);
    const gst = Number(updatedItem.gst || 0);

    let net = rate * qty;
    let discountAmount = (net * discount) / 100;
    let afterDiscount = net - discountAmount;
    let gstAmount = (afterDiscount * gst) / 100;
    let total = afterDiscount + gstAmount;

    updatedItem.net = afterDiscount.toFixed(2);
    updatedItem.amount = total.toFixed(2);

    setItem(updatedItem);
  };

  const netAmount = form.items.reduce((sum, i) => sum + Number(i.net), 0);
  const discountAmount = (netAmount * Number(form.extra_discount || 0)) / 100;
  const afterDiscount = netAmount - discountAmount;
  const gstRate = 18;
  const gstAmount = (afterDiscount * gstRate) / 100;
  const cgst = gstAmount / 2;
  const sgst = gstAmount / 2;
  const freight = Number(form.freight_charge || 0);
  const finalTotal = afterDiscount + gstAmount + freight;

  const addItem = () => {
    let errors = {};

    if (!item.product_id) {
      errors.product_id = "Select product";
    }
    if (!item.rate || Number(item.rate) <= 0) {
      errors.rate = "Rate must be greater than 0";
    }
    if (!item.qty || Number(item.qty) <= 0) {
      errors.qty = "Quantity must be greater than 0";
    }

    if (Object.keys(errors).length > 0) {
      setItemErrors(errors);
      return;
    }

    const rate = Number(item.rate);
    const qty = Number(item.qty);
    const discount = Number(item.discount || 0);
    const gst = Number(item.gst || 0);

    const total = rate * qty;
    const discountAmount = (total * discount) / 100;
    const afterDiscount = total - discountAmount;
    const gstAmount = (afterDiscount * gst) / 100;
    const finalAmount = afterDiscount + gstAmount;

    const newItem = {
      ...item,
      net: afterDiscount.toFixed(2),
      amount: finalAmount.toFixed(2),
    };

    setForm((prev) => ({
      ...prev,
      items: [...prev.items, newItem],
    }));

    setItem({
      product_id: "",
      product_name: "",
      rate: "",
      qty: "",
      discount: "",
      net: "",
      gst: "",
      amount: "",
      description: "",
    });
    setItemErrors({});
  };

  const editItem = (index) => {
    const selected = form.items[index];
    setItem(selected);
    setEditIndex(index);
  };

  const updateItem = () => {
    let errors = {};

    if (!item.product_id) {
      errors.product_id = "Select product";
    }
    if (!item.rate || Number(item.rate) <= 0) {
      errors.rate = "Rate must be greater than 0";
    }
    if (!item.qty || Number(item.qty) <= 0) {
      errors.qty = "Quantity must be greater than 0";
    }

    if (editIndex === null) {
      alert("No item selected for update");
      return;
    }

    if (Object.keys(errors).length > 0) {
      setItemErrors(errors);
      return;
    }

    const rate = Number(item.rate);
    const qty = Number(item.qty);
    const discount = Number(item.discount || 0);
    const gst = Number(item.gst || 0);

    const total = rate * qty;
    const discountAmount = (total * discount) / 100;
    const afterDiscount = total - discountAmount;
    const gstAmount = (afterDiscount * gst) / 100;
    const finalAmount = afterDiscount + gstAmount;

    const updatedItem = {
      ...item,
      net: afterDiscount.toFixed(2),
      amount: finalAmount.toFixed(2),
    };

    const updatedItems = [...form.items];
    updatedItems[editIndex] = updatedItem;

    setForm((prev) => ({
      ...prev,
      items: updatedItems,
    }));

    setItem({
      product_id: "",
      product_name: "",
      rate: "",
      qty: "",
      discount: "",
      net: "",
      gst: "",
      amount: "",
      description: "",
    });
    setEditIndex(null);
    setItemErrors({});
  };

 
  const removeItem = (i) => {
    const updated = form.items.filter((_, index) => index !== i);
    setForm({ ...form, items: updated });
  };

  const showError = (field) => {
    if (!formErrors[field]) return null;
    return (
      <small className="text-danger">
        {Array.isArray(formErrors[field])
          ? formErrors[field][0]
          : formErrors[field]}
      </small>
    );
  };

 const handleSubmit = async () => {
  setFormErrors({});
  let errors = {};

  if (!form.company_id) errors.company_id = "Please select company";
  if (!form.quot_stage_id) errors.quot_stage_id = "Please select quotation stage";
  if (!form.branch_id) errors.branch_id = "Please select branch";
  if (!form.bill_company_name)
    errors.bill_company_name = "Company name is required";
  if (!form.bill_customer_name)
    errors.bill_customer_name = "Customer name is required";
  if (!form.bill_address) errors.bill_address = "Address required";

  if (!form.bill_contact_number) {
    errors.bill_contact_number = "Mobile number required";
  } else if (!/^[6-9]\d{9}$/.test(form.bill_contact_number)) {
    errors.bill_contact_number = "Invalid mobile number";
  }

  if (!form.bill_email) {
    errors.bill_email = "Email required";
  } else if (!/^\S+@\S+\.\S+$/.test(form.bill_email)) {
    errors.bill_email = "Invalid email";
  }

  if (
    form.bill_gst &&
    !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(form.bill_gst)
  ) {
    errors.bill_gst = "Invalid GST";
  }

  if (!form.quot_date) errors.quot_date = "Quotation date is required";
  if (!form.ship_company_name)
    errors.ship_company_name = "Company name is required";
  if (!form.ship_customer_name)
    errors.ship_customer_name = "Customer name is required";
  if (!form.ship_address) errors.ship_address = "Address required";

  if (!form.ship_contact_number) {
    errors.ship_contact_number = "Mobile number required";
  } else if (!/^[6-9]\d{9}$/.test(form.ship_contact_number)) {
    errors.ship_contact_number = "Invalid mobile number";
  }

  if (!form.ship_email) {
    errors.ship_email = "Email required";
  } else if (!/^\S+@\S+\.\S+$/.test(form.ship_email)) {
    errors.ship_email = "Invalid email";
  }

  if (
    form.ship_gst &&
    !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(form.ship_gst)
  ) {
    errors.ship_gst = "Invalid GST";
  }

  if (form.items.length === 0) {
    errors.items = "At least 1 item required";
  }

  if (Object.keys(errors).length > 0) {
    setFormErrors(errors);
    return;
  }

  const itemsToSubmit = form.items.map((item) => ({
    product_id: item.product_id,
    product_name: item.product_name,
    rate: parseFloat(item.rate),
    qty: parseFloat(item.qty),
    discount: parseFloat(item.discount || 0),
    net: parseFloat(item.net),
    gst: parseFloat(item.gst || 0),
    amount: parseFloat(item.amount),
    description: item.description || "",
  }));

  const payload = {
    quot_date: form.quot_date + ":00",
    quot_stage_id: form.quot_stage_id,
    company_id: form.company_id,
    branch_id: form.branch_id,
    bill_company_name: form.bill_company_name,
    bill_customer_name: form.bill_customer_name,
    bill_address: form.bill_address,
    bill_contact_number: form.bill_contact_number,
    bill_email: form.bill_email,
    bill_gst: form.bill_gst,
    ship_company_name: form.ship_company_name,
    ship_customer_name: form.ship_customer_name,
    ship_address: form.ship_address,
    ship_contact_number: form.ship_contact_number,
    ship_email: form.ship_email,
    ship_gst: form.ship_gst,
    freight_charge: parseFloat(form.freight_charge) || 0,
    freight_comment: form.freight_comment,
    extra_discount: parseFloat(form.extra_discount) || 0,
    tc_taxes: form.tc_taxes,
    tc_payment: form.tc_payment,
    tc_shipment_charges: form.tc_shipment_charges,
    tc_delivery_time: form.tc_delivery_time,
    tc_order_placement: form.tc_order_placement,
    tc_quote_validity: form.tc_quote_validity,
    account_detail_id: form.account_detail_id || "",
    quot_remarks: form.quot_remarks,
    items: itemsToSubmit,
    net_amount: netAmount,
    net_discount: discountAmount,
    net_cgst: cgst,
    net_sgst: sgst,
    net_igst: 0,
    netTotal_amount: finalTotal,
  };

  console.log("Submitting payload:", payload);

  if (isSubmitting) return;
  setIsSubmitting(true);

  try {
    const res = await fetch(`${API_URL}/api/quotation/${id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    // session expired / unauthorized
    if (res.status === 401) {
      navigate("/login");
      return;
    }

    const text = await res.text();
    let data;

    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error("Invalid JSON Response:", text);
      throw new Error("Server returned invalid JSON");
    }

    if (!res.ok) {
      console.error("API Error:", data);

      if (data.errors) {
        setFormErrors(data.errors);
      } else {
        alert(data.message || "Server Error");
      }
      return;
    }
    Swal.fire({
              icon: 'success',
              title: 'Quotation Updated Successfully!',
              text: 'Your quotation has been updated successfully.'
            });
    navigate("/quotation");
  } catch (error) {
    console.error("Error:", error);
    alert("Network / Server Error: " + error.message);
  } finally {
    setIsSubmitting(false);
  }
};

  const selectedCompanyOption = companyOptions.find(
    (opt) => opt.value == form.company_id,
  );
  const selectedQuotationStageOption = quotationStageOptions.find(
    (opt) => opt.value == form.quot_stage_id,
  );
  const selectedBranchOption = branchOptions.find(
    (opt) => opt.value == form.branch_id,
  );

  const selectedProductOption = productOptions.find(
    (opt) => opt.value == item.product_id,
  );

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-3">
      <h3>Edit Quotation</h3>

      <div className="quotation-card mb-3">
        <div className="row p-2">
          <div className="col-lg-4">
            <label>Date*</label>
            <input
              type="datetime-local"
              name="quot_date"
              onChange={handleChange}
              value={form.quot_date}
              className="form-control"
            />
            {formErrors.quot_date && (
              <small className="text-danger">{formErrors.quot_date}</small>
            )}
          </div>
             <div className="col-lg-4">
              <label>Quotation stage*</label>
              <Select
                options={quotationStageOptions}
                onChange={(selected) => handleQuotationStageChange(selected)}
                 value={selectedQuotationStageOption}
                placeholder="Select Quotation Stage"
              />
              {formErrors.quot_stage_id && (
            <small className="text-danger">
              {formErrors.quot_stage_id}
            </small>
          )}
          </div>
           <div className="col-lg-4">
              <label>Branch*</label>
              <Select
                options={branchOptions}
                value={selectedBranchOption}
                onChange={(selected) => handleBranchChange(selected)}
                placeholder="Select Branch"
              />
              {formErrors.branch_id && (
            <small className="text-danger">
              {formErrors.branch_id}
            </small>
          )}
          </div>
        </div>
      </div>

      <div className="quotation-card mb-3">
        <div className="p-2">
          <strong>Company name*</strong>
          <Select
            options={companyOptions}
            value={selectedCompanyOption}
            onChange={handleCompanyChange}
            placeholder="Select Company"
          />
          {formErrors.bill_company_name && (
            <small className="text-danger">
              {formErrors.bill_company_name}
            </small>
          )}
        </div>

        <div className="row p-2">
          <div className="col-lg-6">
            <strong>Bill to*</strong>
            <div className="border p-2 rounded">
              <div className="d-flex justify-content-between align-items-center">
                <strong>Company:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="bill_company_name"
                  value={form.bill_company_name}
                  onChange={handleChange}
                />
              </div>
              {showError("bill_company_name")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Customer:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="bill_customer_name"
                  value={form.bill_customer_name}
                  onChange={handleChange}
                />
              </div>
              {showError("bill_customer_name")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Address:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="bill_address"
                  value={form.bill_address}
                  onChange={handleChange}
                />
              </div>
              {showError("bill_address")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Contact:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="bill_contact_number"
                  value={form.bill_contact_number}
                  onChange={handleChange}
                />
              </div>
              {showError("bill_contact_number")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Email:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="bill_email"
                  value={form.bill_email}
                  onChange={handleChange}
                />
              </div>
              {showError("bill_email")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>GST:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="bill_gst"
                  value={form.bill_gst}
                  onChange={handleChange}
                />
              </div>
              {showError("bill_gst")}
            </div>
          </div>

          <div className="col-lg-6">
            <strong>Ship to*</strong>
            <div className="border p-2 rounded">
              <div className="d-flex justify-content-between align-items-center">
                <strong>Company:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="ship_company_name"
                  value={form.ship_company_name}
                  onChange={handleChange}
                />
              </div>
              {showError("ship_company_name")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Customer:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="ship_customer_name"
                  value={form.ship_customer_name}
                  onChange={handleChange}
                />
              </div>
              {showError("ship_customer_name")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Address:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="ship_address"
                  value={form.ship_address}
                  onChange={handleChange}
                />
              </div>
              {showError("ship_address")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Contact:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="ship_contact_number"
                  value={form.ship_contact_number}
                  onChange={handleChange}
                />
              </div>
              {showError("ship_contact_number")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>Email:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="ship_email"
                  value={form.ship_email}
                  onChange={handleChange}
                />
              </div>
              {showError("ship_email")}

              <div className="d-flex justify-content-between align-items-center">
                <strong>GST:</strong>
                <input
                  type="text"
                  className="w-100 px-2 border-0 form-control shadow-none"
                  style={{ height: "calc(1.25rem + 6px)" }}
                  name="ship_gst"
                  value={form.ship_gst}
                  onChange={handleChange}
                />
              </div>
              {showError("ship_gst")}
            </div>
          </div>
        </div>
      </div>

      <div className="quotation-card mb-3 p-2">
        <strong className="mt-4">
          Items* ({form.items.length} items added)
        </strong>
        <table className="table table-bordered mt-3 px-2">
          <thead className="table-light">
            <tr>
              <th style={{ width: "200px" }}>Product</th>
              <th>Rate</th>
              <th>Qty</th>
              {/* <th>Disc (%)</th> */}
              <th>Net</th>
              <th>GST (%)</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Select
                  options={productOptions}
                  value={selectedProductOption}
                  onChange={handleProductChange}
                  placeholder="Select Product"
                />
                {itemErrors.product_id && (
                  <small className="text-danger">{itemErrors.product_id}</small>
                )}
              </td>
              <td>
                <input
                  name="rate"
                  type="number"
                  step="any"
                  value={item.rate}
                  onChange={handleItemChange}
                  className="form-control"
                />
                {itemErrors.rate && (
                  <small className="text-danger">{itemErrors.rate}</small>
                )}
              </td>
              <td>
                <input
                  name="qty"
                  type="number"
                  step="any"
                  value={item.qty}
                  min="1"
                  onChange={handleItemChange}
                  className="form-control"
                />
                {itemErrors.qty && (
                  <small className="text-danger">{itemErrors.qty}</small>
                )}
              </td>
              {/* <td>
                <input
                  name="discount"
                  value={item.discount}
                  onChange={handleItemChange}
                  className="form-control"
                />
              </td> */}
              <td>
                <input
                  name="net"
                  value={item.net}
                  readOnly
                  className="form-control"
                />
              </td>
              <td>
                <input
                  name="gst"
                  type="number"
                  step="any"
                  value={item.gst}
                  onChange={handleItemChange}
                  className="form-control"
                />
              </td>
              <td>
                <input
                  name="amount"
                  value={item.amount}
                  readOnly
                  className="form-control"
                />
              </td>
              <td>
                <textarea
                  name="description"
                  rows={1}
                  value={item.description}
                  onChange={handleItemChange}
                  className="form-control"
                />
              </td>
              <td>
                {editIndex !== null ? (
                  <button onClick={updateItem} className="btn btn-primary">
                    Update
                  </button>
                ) : (
                  <button onClick={addItem} className="btn btn-success">
                    Add
                  </button>
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="table table-bordered mt-3 px-2">
          <thead className="table-light">
            <tr>
              <th>Product</th>
              <th>Rate</th>
              <th>Qty</th>
              {/* <th>Disc (%)</th> */}
              <th>Net</th>
              <th>GST (%)</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {form.items.length > 0 ? (
              form.items.map((i, index) => (
                <tr key={index}>
                  <td style={{ width: "200px" }}>{i.product_name}</td>
                  <td>{i.rate}</td>
                  <td>{i.qty}</td>
                  {/* <td>{i.discount}</td> */}
                  <td>{i.net}</td>
                  <td>{i.gst}</td>
                  <td>{i.amount}</td>
                  <td style={{ width: "250px" }}>
                    {i.description?.split("\n").map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </td>
                  <td>
                    <button
                      onClick={() => editItem(index)}
                      className="btn btn-warning btn-sm me-2"
                    >
                      ✏️
                    </button>
                    <button
                      onClick={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to delete this item?",
                          )
                        ) {
                          removeItem(index);
                        }
                      }}
                      className="btn btn-danger btn-sm"
                    >
                      🗑
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No items added
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {formErrors.items && (
          <div className="text-danger text-center">{formErrors.items}</div>
        )}
      </div>

      {/* Rest of the JSX remains same as your original */}
      <div className="quotation-card mb-3 p-2">
        <div className="row g-4">
          <div className="col-lg-6 py-2">
            <div className="row">
              <div className="col-6">
                <label>Freight Charges</label>
              </div>
              <div className="col-6">
                <input
                  type="number"
                  name="freight_charge"
                  value={form.freight_charge}
                  onChange={handleExtraChange}
                  className="form-control"
                />
              </div>
              <div className="col-12 mt-5">
                <input
                  type="text"
                  name="freight_comment"
                  value={form.freight_comment}
                  onChange={handleExtraChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6 py-2">
            <div className="d-flex justify-content-between">
              <div>Net Amount</div>
              <div>₹ {netAmount.toFixed(2)}</div>
            </div>
            {/* <div className="d-flex justify-content-between">
              <div>Discount ({form.extra_discount}%)</div>
              <div>₹ {discountAmount.toFixed(2)}</div>
            </div> */}
            <div className="d-flex justify-content-between">
              <div>CGST</div>
              <div>₹ {cgst.toFixed(2)}</div>
            </div>
            <div className="d-flex justify-content-between">
              <div>SGST</div>
              <div>₹ {sgst.toFixed(2)}</div>
            </div>
            <div className="d-flex justify-content-between">
              <div>{form.freight_comment || "Freight"}</div>
              <div>₹ {freight.toFixed(2)}</div>
            </div>
            <div className="d-flex justify-content-between fw-bold">
              <div>Total Amount</div>
              <div>₹ {finalTotal.toFixed(2)}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="quotation-card mb-3 p-2">
        <div className="row">
          <div className="col-lg-7">
            <label>Terms & Conditions</label>
            <div className="d-flex flex-nowrap align-items-center mt-2">
              <strong className="me-2">Taxes:</strong>
              <input
                type="text"
                name="tc_taxes"
                value={form.tc_taxes}
                onChange={handleChange}
                className="px-2 border-0 form-control shadow-none"
                style={{ height: "calc(1.25rem + 6px)" }}
              />
            </div>
            <div className="d-flex flex-nowrap align-items-center">
              <strong className="me-2">Payment:</strong>
              <input
                type="text"
                name="tc_payment"
                value={form.tc_payment}
                onChange={handleChange}
                className="px-2 border-0 form-control shadow-none"
                style={{ height: "calc(1.25rem + 6px)" }}
              />
            </div>
            <div className="d-flex flex-nowrap align-items-center">
              <strong className="me-2 text-nowrap">Shipment Charges:</strong>
              <input
                type="text"
                name="tc_shipment_charges"
                value={form.tc_shipment_charges}
                onChange={handleChange}
                className="px-2 border-0 form-control shadow-none"
                style={{ height: "calc(1.25rem + 6px)" }}
              />
            </div>
            <div className="d-flex flex-nowrap align-items-center">
              <strong className="me-2 text-nowrap">Delivery Time:</strong>
              <input
                type="text"
                name="tc_delivery_time"
                value={form.tc_delivery_time}
                onChange={handleChange}
                className="px-2 border-0 form-control shadow-none"
                style={{ height: "calc(1.25rem + 6px)" }}
              />
            </div>
            <div className="d-flex flex-nowrap align-items-center">
              <strong className="me-2 text-nowrap">Order Placement:</strong>
              <input
                type="text"
                name="tc_order_placement"
                value={form.tc_order_placement}
                onChange={handleChange}
                className="px-2 border-0 form-control shadow-none"
                style={{ height: "calc(1.25rem + 6px)" }}
              />
            </div>
            <div className="d-flex flex-nowrap align-items-center">
              <strong className="me-2 text-nowrap">Quote Validity:</strong>
              <input
                type="text"
                name="tc_quote_validity"
                value={form.tc_quote_validity}
                onChange={handleChange}
                className="px-2 border-0 form-control shadow-none"
                style={{ height: "calc(1.25rem + 6px)" }}
              />
            </div>
          </div>
          <div className="col-lg-5">
            <label>Company's Bank Details</label>
            <div className="mt-3">
              <strong>A/C Holder:</strong> {accountDetails?.account_holder_name}
            </div>
            <div>
              <strong>Bank Name:</strong> {accountDetails?.bank_name}
            </div>
            <div>
              <strong>A/C No:</strong> {accountDetails?.account_number}
            </div>
            <div>
              <strong>IFSC:</strong> {accountDetails?.ifsc_code}
            </div>
            <div>
              <strong>Branch:</strong> {accountDetails?.branch}
            </div>
          </div>
        </div>
      </div>

      <div className="quotation-card mb-3 p-2">
        <div className="row">
          <div className="col-lg-6">
            <label>Remarks</label>
            <br />
            <p>
              You can add notes or special instructions for this quotation.
              These remarks will appear in the 'Quotation Remarks' section when
              printed.
            </p>
          </div>
          <div className="col-lg-6">
            <textarea
              name="quot_remarks"
              value={form.quot_remarks}
              onChange={handleChange}
              rows="4"
              className="w-100 p-2 border form-control"
            ></textarea>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end mb-3 pt-2 gap-2">
        <button
          onClick={() => navigate("/quotation")}
          className="btn btn-secondary"
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={isSubmitting}
          className="btn btn-primary d-flex align-items-center gap-2"
        >
          {isSubmitting && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          {isSubmitting ? "Processing..." : "Update Quotation"}
        </button>
      </div>
    </div>
  );
};

export default EditQuotation;
